import spinRoute from '../../router/spinRoute.js';
import kygMsg from '../../js/kygMsg';

export default () => [
    {
        path: '/wish',
        redirect: '/wish/mywish',
        component: () => spinRoute.require(import('./wish.vue')),
        meta: { title: '员工关怀', hideBarFoot: true },
        children: [
            {
                path: '/wish/mywish',
                name: '我的祝福',
                component: () => import('./components/mywish.vue'),
                meta: { title: '祝福墙', hideBarFoot: true },
            },
            {
                path: '/wish/givewish',
                name: '送祝福',
                component: () => import('./components/givewish.vue'),
                meta: { title: '祝福墙', hideBarFoot: true },
            },
            {
                path: '/wish/recordwish',
                name: '送福记录',
                component: () => import('./components/recordwish.vue'),
                meta: { title: '祝福墙', hideBarFoot: true },
            },
        ]
    },
    {
        path: '/writeback',
        component: () => import('./components/writeback.vue'),
        meta: { title: '祝福墙', hideBarFoot: true },
    },
    {
        path: '/checkwish',
        component: () => import('./components/checkwish.vue'),
        meta: { title: '祝福墙', hideBarFoot: true },
    },
    {
        path: '/givegift',
        redirect: '/givegift/gogift',
        component: () => import('./components/give-gift.vue'),
        meta: { title: '送祝福', hideBarFoot: true },
        children: [
            {
                path: '/givegift/gogift',
                component: () => import('./components/gogift.vue'),
                meta: { title: '送祝福', hideBarFoot: true },
            },
            {
                path: '/givegift/gifthistory',
                component: () => import('./components/gifthistory.vue'),
                meta: { title: '送祝福', hideBarFoot: true },
            },
        ]
    }
]
